import { LampDesk } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { useStructureToolGating } from '~/hooks/target/useStructureToolGating';
import { structureIsolationActiveState } from '~/state/atoms/structureSet/roiAtoms';

/**
 * Soft isolate: a display mode that holds the selected structure at full
 * contour intensity and dims the rest, keeping them on screen as context.
 *
 * One control governs the mode for the whole display and the spotlight
 * follows the selection, so it lives with the other viewport display modes
 * rather than with a structure's own actions. Without a selection there is
 * nothing to spotlight and the renderer dims nothing, so the button says so
 * instead of switching on a mode with no visible effect.
 */
export default function IsolateTool() {
    const intl = useIntl();
    const { hasSelectedRoi } = useStructureToolGating();
    const [isolationActive, setIsolationActive] = useRecoilState(
        structureIsolationActiveState
    );

    const tooltipId = !hasSelectedRoi
        ? 'structure.isolate.noSelection'
        : isolationActive
          ? 'structure.isolate.off'
          : 'structure.isolate.on';

    return (
        <ToolbarButton
            icon={<LampDesk />}
            tooltip={intl.formatMessage({ id: tooltipId })}
            disabled={!hasSelectedRoi}
            selected={isolationActive}
            ariaPressed={isolationActive}
            onClick={() => setIsolationActive((previous) => !previous)}
            data-testid="tool-structure-isolate"
        />
    );
}
